module.exports = __webpack_public_path__ + "static/media/533.ed792fc6.svg";